export const CARD_VIEWER_QUERY_PARAMS = {
  VIEW_CARD: 'viewCard',
  RANK: 'rank',
  SECTION: 'section',
} as const;
